/**
 * RESPONSIBILITY: draw the /adc page's closing invitation and its small footer.
 *
 * The page ends by asking again, with the same button the header has: a person who has
 * scrolled this far has been persuaded, and should not have to scroll back up to act.
 * The button's words and link belong to the opening section, so they are handed in
 * rather than entered twice.
 */
import type { AdcFootSection } from '@app/sections';

export interface AdcCta { label: string; href: string }

export function AdcFoot({ c, cta }: { c: AdcFootSection; cta?: AdcCta }) {
  const button = cta?.href && cta.label
    ? <a className="btn btn-gold" href={cta.href}>{cta.label}</a>
    : null;

  return (
    <>
      {c.line || c.verse || button ? (
        <section className="adc-close">
          <div className="adc-close-inner">
            {c.line ? <h2>{c.line}</h2> : null}
            {c.verse ? <p className="adc-verse">{c.verse}</p> : null}
            {button}
          </div>
        </section>
      ) : null}
      <footer className="adc-footer">
        <p className="adc-foot-links">
          {c.contact ? <a href={`mailto:${c.contact}`}>{c.contact}</a> : null}
          {c.siteHref ? <a href={c.siteHref}>{c.siteLabel || c.siteHref}</a> : null}
        </p>
        {c.smallPrint ? <p className="adc-foot-small">{c.smallPrint}</p> : null}
      </footer>
    </>
  );
}
